export enum RoleSearchFields {
	searchByCode = 'searchByCode',
	searchByName = 'searchByName'
}

export declare namespace Role {
	interface Basic extends NameCode {
		id: number
		createDate: string
		lastUpdated: string
	}

	interface BasicFormId extends Pick<Basic, 'code' | 'name' | 'id'> {
		privileges: Entity[]
	}

	namespace Form {
		interface AddRole extends Pick<Basic, 'code' | 'name'> {
			privileges: LabelValue<number>[]
		}

		interface NewRole extends Pick<Basic, 'code' | 'name'> {
			privilegeIds: number[]
		}
	}

	namespace Search {
		interface Result {
			[RoleSearchFields.searchByCode]: Entity[]
			[RoleSearchFields.searchByName]: Entity[]
		}
	}
}
